module.exports = __webpack_public_path__ + "media/images/vectorsol4-8607b92f648fcead743e8d3650bbef6b.png";